<template>
  <div class="nodata-tips [v-cloak]">
    <img  v-if="image.length > 0" :src="'images/'+ image +'.png'"
          class="tip-photos" :class="image"/>
    <div class="tips-content" :class="image.length === 0 ? 'no-img':''">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DivNoData',
  props: {
    image: {
      type: String,
      default: function () {
        return 'empty-data'
      }
    }
  }
}
</script>

<style scoped>
  .nodata-tips {
    height: 250px;
    text-align: center;
    position: relative;
  }

  .nodata-tips .tip-photos {
    margin-bottom: 10px;
  }

  .empty-data {
    height: 204px;
    width: 296px;
    position: absolute;
    top: calc(50% - 102px);
    left: calc(50% - 145px);
  }

  .tips-content {
    position: absolute;
    top: calc(50% + 118px);
    left: 10%;
    text-align: center;
    width: 80%;
    color: rgb(153, 153, 153);
  }

  .tips-content.no-img {
    top: 50% !important;
  }

</style>
